import { render, staticRenderFns } from "./studentcycle.vue?vue&type=template&id=08a6da96&scoped=true"
import script from "./studentcycle.vue?vue&type=script&lang=js"
export * from "./studentcycle.vue?vue&type=script&lang=js"
import style0 from "./studentcycle.vue?vue&type=style&index=0&id=08a6da96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a6da96",
  null
  
)

export default component.exports